import {
  IconAirplane,
  IconLocation,
  IconOffersMobile,
  IconTime,
  IconTrain,
  IconGeolocation,
  IconHotel,
  IconGrid,
  IconLocationServices,
} from '@americanexpress/dls-icons';

export const ADDRESS_KEY = 'ADDRESS';
export const AIRPORT_KEY = 'AIRPORT';
export const FLIGHT_KEY = 'FLIGHT';
export const PACKAGE_KEY = 'PACKAGE';
export const HOTEL_KEY = 'HOTEL';
export const CITY_KEY = 'CITY';
export const CAR_KEY = 'CAR';
export const POI_KEY = 'POI';
export const GENERIC_LOCATION_KEY = 'GENERIC_LOCATION';
export const NEIGHBORHOOD_KEY = 'NEIGHBORHOOD';
export const REGION_KEY = 'REGION';
export const TRAIN_STATION_KEY = 'TRAINSTATION';
export const THC_KEY = 'THC';
export const FHR_KEY = 'FHR';
export const GUESTBOOK_KEY = 'GUESTBOOK';
export const AIR_KEY = 'AIR';
export const RECENT_SEARCHES_KEY = 'RECENTSEARCHES';
export const CHANNEL_NAME = 'TLSONLINE';
export const RECENT_SEARCH_FEEDBACK_AIR = 'AIR_SEARCH_FB';
export const RECENT_SEARCH_FEEDBACK_HOTEL = 'HTL_SEARCH_FB';
export const RECENT_SEARCH_EVENT_TYPE = 'GLOBAL_ONLINE_TLSONLINE_FEEDBACK';

export const RECENT_SEARCHES = {
  key: RECENT_SEARCHES_KEY,
  iconNode: IconTime,
  copy: 'recentSearches',
};

export const AIRPORT = {
  key: AIRPORT_KEY,
  iconNode: IconAirplane,
  copy: 'airports',
};

export const HOTEL = {
  key: HOTEL_KEY,
  iconNode: IconHotel,
  copy: 'hotel',
};

export const CITY = {
  key: CITY_KEY,
  iconNode: IconLocation,
  copy: 'cities',
};

export const POI = {
  key: POI_KEY,
  iconNode: IconGeolocation,
  copy: 'points_of_interest',
};

export const GENERIC_LOCATION = {
  key: GENERIC_LOCATION_KEY,
  iconNode: IconGeolocation,
  copy: 'generic_location',
};

export const NEIGHBORHOOD = {
  key: NEIGHBORHOOD_KEY,
  iconNode: IconGrid,
  copy: 'neighborhood',
};

export const REGION = {
  key: REGION_KEY,
  iconNode: IconOffersMobile,
  copy: 'region',
};

export const ADDRESS = {
  key: ADDRESS_KEY,
  iconNode: IconLocationServices,
  copy: 'address',
};

export const TRAIN_STATION = {
  key: TRAIN_STATION_KEY,
  iconNode: IconTrain,
  copy: 'train',
};

export const SEARCH_TYPES = {
  FLIGHT: {
    key: FLIGHT_KEY,
    priority:
      [RECENT_SEARCHES, AIRPORT, CITY, NEIGHBORHOOD, HOTEL, REGION, POI, TRAIN_STATION, ADDRESS],
  },
  PACKAGE: {
    key: FLIGHT_KEY,
    priority:
      [RECENT_SEARCHES, AIRPORT, CITY, NEIGHBORHOOD, HOTEL, REGION, POI, TRAIN_STATION, ADDRESS],
  },
  HOTEL: {
    key: HOTEL_KEY,
    priority:
      [RECENT_SEARCHES, CITY, AIRPORT, HOTEL, NEIGHBORHOOD, REGION, POI, TRAIN_STATION, ADDRESS],
  },
  CAR: {
    key: CAR_KEY,
    priority: [AIRPORT, CITY, ADDRESS, TRAIN_STATION, NEIGHBORHOOD, HOTEL, REGION, POI],
  },
  THC: {
    key: THC_KEY,
    priority: [CITY, HOTEL, REGION],
  },
  FHR: {
    key: FHR_KEY,
    priority: [CITY, HOTEL, REGION],
  },
  GUESTBOOK: {
    key: 'GUESTBOOK',
    priority: [
      CITY,
      AIRPORT,
      NEIGHBORHOOD,
      REGION,
      POI,
      HOTEL,
      TRAIN_STATION,
      ADDRESS,
      GENERIC_LOCATION,
    ],
  },
};

export const GUESTBOOK_TYPE_MAP = {
  // Airports
  [AIRPORT_KEY]: [
    'airport',
  ],
  // Hotels and accommodations
  [HOTEL_KEY]: [
    'lodging',
    'campground',
    'rv_park',
  ],
  // Train/transit stations
  [TRAIN_STATION_KEY]: [
    'train_station',
    'transit_station',
    'light_rail_station',
    'subway_station',
    'bus_station',
  ],
  // Neighborhoods and sublocalities
  [NEIGHBORHOOD_KEY]: [
    'neighborhood',
    'sublocality',
    'sublocality_level_1',
    'sublocality_level_2',
    'sublocality_level_3',
    'sublocality_level_4',
    'sublocality_level_5',
  ],
  // Addresses and premises
  [ADDRESS_KEY]: [
    'route',
    'street_address',
    'street_number',
    'premise',
    'subpremise',
  ],
  // Cities and political entities
  [CITY_KEY]: [
    'locality',
    'political',
    'postal_town',
  ],
  // Regions and administrative areas
  [REGION_KEY]: [
    'country',
    'continent',
    'archipelago',
    'administrative_area_level_1',
    'administrative_area_level_2',
    'administrative_area_level_3',
    'administrative_area_level_4',
    'administrative_area_level_5',
    'administrative_area_level_6',
    'administrative_area_level_7',
  ],
  //
  // Points of interest
  [POI_KEY]: [
    'point_of_interest',
    'landmark',
    'natural_feature',
    'park',
  ],
  // Generic location category for types that don't fit other categories
  [GENERIC_LOCATION_KEY]: [
    'establishment',
    'amusement_park',
    'aquarium',
    'art_gallery',
    'atm',
    'bakery',
    'bank',
    'bar',
    'beauty_salon',
    'bicycle_store',
    'book_store',
    'bowling_alley',
    'cafe',
    'car_dealer',
    'car_rental',
    'car_repair',
    'car_wash',
    'casino',
    'cemetery',
    'church',
    'city_hall',
    'clothing_store',
    'convenience_store',
    'courthouse',
    'dentist',
    'department_store',
    'doctor',
    'drugstore',
    'electrician',
    'electronics_store',
    'embassy',
    'fire_station',
    'florist',
    'funeral_home',
    'furniture_store',
    'gas_station',
    'gym',
    'hair_care',
    'hardware_store',
    'hindu_temple',
    'home_goods_store',
    'hospital',
    'insurance_agency',
    'jewelry_store',
    'laundry',
    'lawyer',
    'library',
    'liquor_store',
    'local_government_office',
    'locksmith',
    'meal_delivery',
    'meal_takeaway',
    'mosque',
    'movie_rental',
    'movie_theater',
    'moving_company',
    'museum',
    'night_club',
    'painter',
    'parking',
    'pet_store',
    'pharmacy',
    'physiotherapist',
    'plumber',
    'police',
    'post_office',
    'primary_school',
    'real_estate_agency',
    'restaurant',
    'roofing_contractor',
    'school',
    'secondary_school',
    'shoe_store',
    'shopping_mall',
    'spa',
    'stadium',
    'storage',
    'store',
    'supermarket',
    'synagogue',
    'taxi_stand',
    'tourist_attraction',
    'travel_agency',
    'university',
    'veterinary_care',
    'zoo',
    'accounting',
    'finance',
    'general_contractor',
    'place_of_worship',
  ],
};
